import styleText from './as-trinckle-label.css?raw';

export class AsTrinckleLabel extends HTMLElement {
  static readonly tag = 'as-trinckle-label' as const;

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsTrinckleLabel._sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <as-text dict-key="footer.trinckle-label">
        trinckle design automation application | Powered by paramate
      </as-text>
    `;
  }
}

if (!customElements.get(AsTrinckleLabel.tag)) {
  customElements.define(AsTrinckleLabel.tag, AsTrinckleLabel);
}
